import { render, staticRenderFns } from "./note_mobile_card.vue?vue&type=template&id=5e442aba&scoped=true&"
import script from "./note_mobile_card.vue?vue&type=script&lang=js&"
export * from "./note_mobile_card.vue?vue&type=script&lang=js&"
import style0 from "./note_mobile_card.vue?vue&type=style&index=0&id=5e442aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e442aba",
  null
  
)

export default component.exports